import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutLaneSendToContacts extends Layout {
    sourcePnnBuilderSendto: DataSource;
    tableSendToContacts: Table;
}
